<template>
  <v-container>
    <v-card outlined :loading="loadingMain" :disabled="loadingMain">
      <v-toolbar flat>
        <v-toolbar-title>Cronograma Físico Sintético (Orçamento)</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" small dark fab v-bind="attrs" v-on="on">
              <v-icon>mdi-hammer-wrench </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="getExportExcel()">
              <v-list-item-title>
                <v-icon class="mr-2"> mdi-file-excel </v-icon>
                Exportar Excel
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-spacer></v-spacer>
        <v-select
          style="max-width: 500px"
          class="mt-6"
          rounded
          outlined
          dense
          item-value="id"
          v-model="selected_stages"
          :items="select_stages"
          label="Etapas"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item.name.substring(0, 30) }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ selected_stages.length - 1 }} Outros)
            </span>
          </template>
        </v-select>
        <v-btn class="ml-4" color="primary" rounded @click="index()">Aplicar</v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn
          :loading="loadingSave"
          :disabled="loadingSave"
          rounded
          large
          color="primary"
          style="width: 150px"
          @click="save()"
        >
          Salvar</v-btn
        > -->
      </v-toolbar>

      <!-- ETAPAS  -->
      <v-simple-table dense style="border: 1px solid black">
        <template v-slot:default>
          <thead>
            <tr style="background: #1976d2">
              <th
                class="text-left"
                style="width: 650px; border: 1px solid black; color: white"
              >ETAPAS</th>
              <th class="text-right" style="border: 1px solid black; color: white">HH TOTAL</th>
              <th
                style="border: 1px solid black; color: white"
                v-for="(title, idx) in titles"
                :key="'title-' + idx"
                class="text-right"
              >
                {{ title }}
              </th>
              <th class="text-center" style="border: 1px solid black; color: white">TOTAL</th>
            </tr>

          </thead>
          <tbody>
            <template v-for="(item, index) in stages">
              <tr
                :key="index"
                :style="{
                  background: [
                    '#ffff99', // 1
                    '#b3c6e7', // 0
                    '#dbdbdb', // 2
                    '#ffe699', // 3
                    '#c5e0b4', // 4
                  ][index % 5],
                }"
              >
                <td style="border-top: 2px solid black;border-right: 0.5px solid black;border-bottom: 2px solid black;border-left: 2px solid black" :rowspan="2">
                  {{ item.stage.code + " - " + item.stage.name }}
                </td>
                <td style="border-bottom: 0.5px solid black;border-top: 2px solid black" class="text-right">
                  {{ item.hh_total != 0 ? formatMoney(item.hh_total) : "" }}
                </td>
                <td
                  :style="{ background: ite.hh > 0 ? '' : 'white' }"
                  style="border-bottom: 0.5px solid black;border-top: 2px solid black;border-left: 0.5px solid black"
                  class="text-right"
                  v-for="(ite, index) in item.data"
                  :key="'c-' + item.id + index"
                >
                  {{ ite.hh != 0 ? formatMoney(ite.hh) : "" }}
                </td>
                <td style="border-top: 2px solid black;border-right: 2px solid black;border-bottom: 0.5px solid black;border-left: 0.5px solid black"  class="text-right">{{item.total_data_hh !=0? formatMoney(item.total_data_hh):''}}</td>
              </tr>
              <tr
                :style="{
                  background: [
                    '#ffff99', // 1
                    '#b3c6e7', // 0
                    '#dbdbdb', // 2
                    '#ffe699', // 3
                    '#c5e0b4', // 4
                  ][index % 5],
                }"
                :key="'c1-' + item.id + index">
                <td style="border-bottom: 2px solid black" class="text-right">{{item.hh_total != 0 ? '100%' : ''}}</td>
                <td
                  :style="{ background: ite.hh > 0 ? '' : 'white' }"
                  style="border-bottom: 2px solid black;border-left: 0.5px solid black"
                  class="text-right"
                  v-for="(ite, index) in item.data"
                  :key="'p-' + item.id + index"
                >
                  {{ ite.percentage > 0 ? formatMoney(ite.percentage) + " %" : "" }}
                </td>
                <td style="border-right: 2px solid black;border-bottom: 2px solid black;border-left: 0.5px solid black" class="text-right">{{item.percentage_data_hh != 0 ? formatMoney(item.percentage_data_hh)+'%':''}}</td>
              </tr>
            </template>
          </tbody>

        </template>
      </v-simple-table>
      <div v-if="titles.length > 0">
          <v-card class="mt-4">
            <v-simple-table dense outlined style="border: 1px solid black">
                <template v-slot:default>
                <tbody>
                  <tr style="background: lightgray; color: black">
                    <td rowspan="3" style="border: 1px solid black; width:650px;font-size: 12px">TOTAL</td>
                    <td style="border: 1px solid black;width:100px;font-size: 12px" class="text-center;">HH TOTAL</td>
                    <td
                      style="border: 1px solid black;font-size: 12px"
                      v-for="(title, idx) in titles"
                      :key="'total-' + idx"
                      class="text-center"
                    >
                     {{ title }}
                    </td>
                    <td style="border: 1px solid black;color:black;" class="text-center">TOTAL</td>
                  </tr>
                   <tr style="background: lightgray; color: white">
                    <td style="border: 1px solid black;color:black" class="text-center">{{formatMoney(subtotal.hh_total)}}</td>
                    <td
                      style="border: 1px solid black;color:black"
                      v-for="(item, idx) in subtotal.data"
                      :key="'total-' + idx"
                      class="text-right"
                    >
                    {{ item.hh != 0 ? formatMoney(item.hh) : ""  }}
                    </td>

                    <td style="border: 1px solid black;color:black" class="text-right">{{ subtotal.total_data_percentage!= 0 ? formatMoney(subtotal.total_data_hh):'' }}</td>
                  </tr>
                   <tr style="background: lightgray; color: black">
                    <td style="border: 1px solid black" class="text-right">100%</td>
                    <td
                      style="border: 1px solid black;color:black"
                      v-for="(item, idx) in subtotal.data"
                      :key="'total-' + idx"
                      class="text-right"
                    >
                    {{  item.percentage != 0?(formatMoney(item.percentage) + "%"):''  }}
                    </td>
                    <td style="border: 1px solid black;color:black;text-align:right">{{subtotal.total_data_percentage!= 0 ? formatMoney(subtotal.total_data_percentage)+'%':''}}</td>
                  </tr>
              </tbody>
              </template>
            </v-simple-table>
           </v-card>
      </div>
    </v-card>
    <!-- Dialog for scheduling service -->
    <!-- <DialogScheduleService
      v-model="dialog_schedule_service"
      @updatePhysicalSchedule="updatePhysicalSchedule"
      :physical_schedule="physical_schedule"
    /> -->
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
// import DialogScheduleService from "./components/DialogScheduleService.vue";
export default {
  components: {
    // DialogScheduleService,
  },
  data() {
    return {
      selected_stages: [],
      select_stages: [],

      physical_schedule: null,
      selectedComposition: null,
      selectedStage: null,
      loadingMain: false,
      loadingSave: false,
      dialog_schedule_service: false,
      stages: [],
      titles: [],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("BudgetPhysicalSchedule", [
      "indexSyntheticSchedule",
      "getExportsSyntheticExcel",
      "loadSelectStages",
    ]),
    initialize() {
      //carrega os items do select stages
      this.loadingSelectStages = true;
      this.loadSelectStages()
        .then((response) => {
          this.select_stages = response.data;
        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar as etapas do select");
        })
        .finally(() => {
          this.loadingSelectStages = false;
        });

      this.index();
    },
    index() {
      let stages_ids = this.selected_stages.join(",");
      this.loadingMain = true;
      this.indexSyntheticSchedule(stages_ids)
        .then((response) => {
          this.stages = response.data.data;
          this.titles = response.data.titles;
          this.subtotal = response.data.subtotal;
        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar as etapas");
        })
        .finally(() => {
          this.loadingMain = false;
        });
    },

    //somatorio de hh total de cada etapa
    calcSumHHTotal(stage) {
      //somatorio da coluna hh_total
      return stage.reduce((acc, item) => {
        return acc + item.hh_total;
      }, 0);
    },
    //somatorio de a realizar de cada etapa
    calcSumARealizar(stage) {
      //somatorio da coluna hh_a_realizar
      return stage.reduce((acc, item) => {
        return acc + item.a_realizar;
      }, 0);
    },
    /**
     * Exporta para Excel
     */

    getExportExcel() {
      let stages_ids = this.selected_stages.join(",");
      this.getExportsSyntheticExcel(stages_ids).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "export.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },

    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
    formatDate(date) {
      if (date) {
        let date_split = date.split("-");
        return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      }
      return "";
    },
    stringLong(composition_name) {
      if (composition_name.length > 150) {
        return "...";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.title_table {
  font-size: 16px;
  margin-top: 20px;
  width: 100%;
  height: 32px;
  background: #1976d2;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  padding-top: 3px;
}
</style>
